<template>
  <div>
    <el-dialog
        title="Áp dụng cho người dùng"
        :visible.sync="showApplicableToUsersDialog"
        width="1500px"
        @open="handleOpen"
        :before-close="handleClose">
      <el-form :model="dataForm" :rules="rules" ref="ruleForm">
        <el-form-item label="Chọn người dùng" prop="user">
          <el-transfer
              v-model="dataForm.user"
              :data="listUserDB"
              :props="{ key: 'idUser', label: 'name' }"
              filterable
              filter-placeholder="Tìm người dùng"
              :titles="[ 'Danh sách người dùng', 'Đã chọn' ]"
              @change="handleSingleSelect"
          />
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
          <el-button type="success" @click="submitForm" v-loading="loadingButton" :disabled="exitButton">Áp dụng</el-button>
          <el-button @click="handleClose" type="danger">Đóng</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import RecognitionManagerService from "@/services/SchoolService/RecognitionManagerService";
import recognitionManagerService from "@/services/SchoolService/RecognitionManagerService";
import NotifyMessage from "@/commonFuncion/NotifyMessage";

export default {
  name: "ApplicableToUsersDialog",
  props: {
    showApplicableToUsersDialog: {
      type: Boolean,
      default: () => false
    },
    idDevice: {
      type: Number,
      default: () => 0
    },
    idUserDeviceRecognition: {
      type: Number,
      default: () => 0
    }
  },
  data() {
    return {
      listUserDB: [],
      exitButton: false,
      dataForm: {
        user: []
      },
      rules: {
        user: [
          { required: true, message: 'Chọn người dùng được áp dụng', trigger: 'change' }
        ]
      },
      loadingButton: false
    }
  },
  methods: {
    handleClose() {
      this.$emit('close');
      this.listUserDB = [];
      this.dataForm.user = [];
    },
    handleSingleSelect(newValue) {
      // Nếu chọn nhiều hơn 1, chỉ giữ lại cái cuối cùng
      if (newValue.length > 1) {
        this.exitButton = true;
        NotifyMessage.leftCornerNotificationError("Chỉ được chọn 1 học sinh")
      }else {
        this.exitButton = false
      }
    },
    async handleOpen() {
      try {
        const response = await RecognitionManagerService.getListUsersNoFace(this.$props.idDevice);
        this.listUserDB = response.data.data.map(item => {
          const name = item.name || '';
          let typeAccount = 'unknown';

          if (name.includes('HS')) {
            typeAccount = 'parent';
          } else if (name.includes('NS')) {
            typeAccount = 'teacher';
          }

          return {
            ...item,
            typeAccount
          };
        });
      } catch (error) {
        console.log(error);
      }
    },
    submitForm() {
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.loadingButton = true;
          let object = {}
          for (let i = 0; i < this.listUserDB.length; i++) {
            if (this.dataForm.user[0] === this.listUserDB[i].idUser) {
              object = this.listUserDB[i]
              break;
            }
          }
          recognitionManagerService.applyUserFromDevice(object.idUser, object.typeAccount, this.$props.idUserDeviceRecognition).then(response => {
            if (response.data.data === true) {
              NotifyMessage.leftCornerNotificationSuccess(response.data.message);
            }else {
              NotifyMessage.error(response.data.message);
            }
          }).catch(error => {
            console.log(error);
            NotifyMessage.leftCornerNotificationError("Cập nhật thất bại")
          }).finally(
              this.loadingButton = false,
              this.handleClose()
          )
        }
      });
    },
  }
};
</script>
<style lang="scss" scoped>
/deep/ .el-transfer-panel__body {
  height: 300px;
}

/deep/ .el-transfer-panel__list.is-filterable {
  height: 245px;
  padding-top: 0;
}

/deep/ .el-transfer-panel .el-transfer-panel__header {
  background: #78a5e7;
}

/deep/ .el-transfer-panel
.el-transfer-panel__header
.el-checkbox
.el-checkbox__label
span {
  color: white;
}

/deep/ .el-transfer-panel .el-transfer-panel__header .el-checkbox .el-checkbox__label {
  color: white;
}

/deep/ .el-transfer-panel {
  width: 500px
}
</style>